import { TranslationApiModel } from './translation.api-model';
import { ModuleApiModel } from '../../module/models/module.api-model';

export interface TranslationKeyApiModel {
  id: string;
  key: string;
  module?: { data: ModuleApiModel };
  translations: TranslationApiModel[];
}
